export default "__VITE_ASSET__c5242b2c__"